var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "976BBCF7-37B3-49F2-8F01-D569DC3887AF") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 0 47.9999 0 47.9999 48 0 48"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Weboldal",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Synflex-Swagers",
    transform: "translate(-489.000000, -1011.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(489.000000, 1011.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.9072,23.773 L21.5812,20.331 C21.3222,20.184 20.4342,20.371 20.4342,20.669 L20.4342,27.38 C20.4342,27.675 21.3152,27.863 21.5742,27.722 L28.1822,24.453 C28.4512,24.308 28.1722,23.924 27.9072,23.773",
    id: "Fill-1",
    fill: "#363636"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-5"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.849,27.368 C36.849,30.551 34.269,33.131 31.086,33.131 L16.349,33.131 C13.166,33.131 10.586,30.551 10.586,27.368 L10.586,20.51 C10.586,17.327 13.166,14.747 16.349,14.747 L31.086,14.747 C34.269,14.747 36.849,17.327 36.849,20.51 L36.849,27.368 Z M35.444,0 L12.556,0 C5.65,0 0,5.65 0,12.556 L0,35.444 C0,42.35 5.65,48 12.556,48 L35.444,48 C42.35,48 48,42.35 48,35.444 L48,12.556 C48,5.65 42.35,0 35.444,0 L35.444,0 Z",
    id: "Fill-3",
    fill: "#363636",
    mask: "url(#mask-2)"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.e462efa903e44d4b65962ab702d8aba4.svg";
export { ForwardRef as ReactComponent };